module.exports = __webpack_public_path__ + "static/media/GoBeRobotSide.c4373a7f.jpg";